import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import NavBar from "./NavBar";

const MainLayout = () => {
  const location = useLocation();
  const path = location.pathname;

  const hideNavbar = path === "/login" || path === "/register" || (path.startsWith("/exams/") && path.includes("/start"));

  return (
    <>
      
      {!hideNavbar &&   <NavBar />}
      <Outlet />
    </>
  );
};

export default MainLayout;
